import { useState } from "react";
import PropTypes from "prop-types";
import { ChevronDown } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import TransferContactsDialog from "components/modals/TransferContactsDialog";
import MergeContactsModal from "routes/contact/components/MergeContactsModal";

const TRANSFER_DIALOG = "transfer";
const MERGE_DIALOG = "merge";

const TRANSFER_ACLS = [
  ACL_RELATIONSHIPS.entityContact.create,
  ACL_RELATIONSHIPS.entityForFilters.read,
];
const MERGE_ACLS = [ACL_RELATIONSHIPS.contactMerge.create];

/** The Actions dropdown above the Contacts and Campaign Contacts tables. */
const ContactsActionButtons = ({
  selectedIds = [],
  selectedData = [],
  uncheckAll,
  invalidateData,
}) => {
  const [openDialog, setOpenDialog] = useState(null);
  const hasSelection = selectedIds.length > 0;

  const closeDialogUnlessOpening = isOpen => {
    if (!isOpen) setOpenDialog(null);
  };

  const handleFinish = async () => {
    uncheckAll();
    await invalidateData();
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          disabled={!hasSelection}
          className={buttonVariants({ variant: "outline", size: "sm" })}
        >
          Actions
          <ChevronDown />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          <Authorized permissions={TRANSFER_ACLS}>
            <DropdownMenuItem onClick={() => setOpenDialog(TRANSFER_DIALOG)}>
              Transfer Contacts
            </DropdownMenuItem>
          </Authorized>
          <Authorized permissions={MERGE_ACLS}>
            <DropdownMenuItem
              disabled={selectedData.length !== 2}
              onClick={() => setOpenDialog(MERGE_DIALOG)}
            >
              Merge Contacts
            </DropdownMenuItem>
          </Authorized>
        </DropdownMenuContent>
      </DropdownMenu>
      <TransferContactsDialog
        open={openDialog === TRANSFER_DIALOG}
        onOpenChange={closeDialogUnlessOpening}
        contactIds={selectedIds}
        onSaved={handleFinish}
      />
      <Authorized permissions={MERGE_ACLS}>
        <MergeContactsModal
          open={openDialog === MERGE_DIALOG}
          onOpenChange={closeDialogUnlessOpening}
          contacts={selectedData}
          finishMerge={invalidateData}
        />
      </Authorized>
    </>
  );
};

ContactsActionButtons.propTypes = {
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  selectedData: PropTypes.arrayOf(PropTypes.object),
  uncheckAll: PropTypes.func.isRequired,
  invalidateData: PropTypes.func.isRequired,
};

export default ContactsActionButtons;
